import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import NavigationButtons from '../../components/NavigationButtons';

import { FadeIn, NumberInput, Label } from 'hosman-material';

import { updateEstimationData } from '../../../../../../reducers/_Pages/Public/estimationFunnelSlice';

const PriceExpectations = () => {
  const { estimationData, estimationData: { priceExpectations }} = useSelector((state) => state.estimationFunnel);
  const dispatch = useDispatch();

  return (
    <div data-testid='PriceExpectations'>
      <FadeIn>
        <div className='flex flex-col gap-6'>
          <p className='h2 text-ih-indigo'>Quel serait votre prix de vente idéal ?</p>

          <div className='relative'>
            <NumberInput
              name='price_expectations'
              placeholder='0'
              onChange={(e) => dispatch(updateEstimationData({
                ...estimationData,
                priceExpectations: e.target.value
              }))}
              value={priceExpectations}
              sign='€'
              autoFocus
            />

            <div className='absolute right-6 -top-3'>
              <Label color='bg-ih-purple'>Facultatif</Label>
            </div>
          </div>
          
          <NavigationButtons classes='hidden md:block my-5' />
        </div>
      </FadeIn>
    </div>
  )
}

export default PriceExpectations;
